import { PageContainer, PageHeader } from '@/components/common'
import { useOrganization } from '@/contexts/OrganizationContext'
import { UNSCHEDULED_RECIPE } from './prepackSchedulePaths'
import SchedulePacksPanel from './SchedulePacksPanel'

/**
 * Schedules → Unscheduled packs (#1080): the packs no live schedule made,
 * that is drafts saved from Create and packs whose schedule was deleted,
 * with the list every schedule's page has. Every Prepacks role can open it;
 * a viewer gets the list and a read-only drawer.
 */
export default function PrepacksUnscheduledPage() {
  const { currentOrg } = useOrganization()
  return (
    <PageContainer>
      <PageHeader
        title="Unscheduled packs"
        description="Packs no schedule made: drafts saved from Create, and packs whose schedule was deleted. A schedule’s own packs are listed on its page, under Packs."
      />
      {/* The same card as a schedule's page: a heading with the count beside it. */}
      <SchedulePacksPanel
        slug={currentOrg?.slug}
        recipe={UNSCHEDULED_RECIPE}
        heading="Packs"
        className="rounded-lg border border-[var(--prepacks-border)] bg-[var(--prepacks-surface)]"
        emptyTitle="No unscheduled packs"
        emptyDescription="Drafts saved from Create, and packs whose schedule was deleted, are listed here until their first game starts."
      />
    </PageContainer>
  )
}
